import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "box-date-time" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode()
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = { class: "mr-3" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode()
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode()
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode()
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimeSelectorComponent = _resolveComponent("TimeSelectorComponent")
  const _component_WeekDaysSelectorComponent = _resolveComponent("WeekDaysSelectorComponent")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.triggerOrActionToAdd.time != undefined)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("small", null, _toDisplayString(_ctx.$t('AppResource.Time').toUpperCase()), 1),
          _hoisted_3,
          _hoisted_4,
          _createVNode(_component_TimeSelectorComponent, {
            modelValue: _ctx.triggerOrActionToAdd.time,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.triggerOrActionToAdd.time = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_5,
          _hoisted_6,
          _createVNode("small", null, _toDisplayString(_ctx.$t('AppResource.RepetitionUpper')), 1),
          _hoisted_7,
          _hoisted_8,
          _createVNode(_component_WeekDaysSelectorComponent, {
            modelValue: _ctx.triggerOrActionToAdd.weekDays,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.triggerOrActionToAdd.weekDays = $event))
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.triggerOrActionToAdd.startTime != undefined)
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode("small", null, _toDisplayString(_ctx.$t('AppResource.From').toUpperCase()), 1),
              _hoisted_12,
              _hoisted_13,
              _createVNode(_component_TimeSelectorComponent, {
                modelValue: _ctx.triggerOrActionToAdd.startTime,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.triggerOrActionToAdd.startTime = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createVNode("div", null, [
              _createVNode("small", null, _toDisplayString(_ctx.$t('AppResource.To').toUpperCase()), 1),
              _hoisted_14,
              _hoisted_15,
              _createVNode(_component_TimeSelectorComponent, {
                modelValue: _ctx.triggerOrActionToAdd.endTime,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.triggerOrActionToAdd.endTime = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_16,
          _hoisted_17,
          _createVNode("small", null, _toDisplayString(_ctx.$t('AppResource.RepetitionUpper')), 1),
          _hoisted_18,
          _hoisted_19,
          _createVNode(_component_WeekDaysSelectorComponent, {
            modelValue: _ctx.triggerOrActionToAdd.weekDays,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.triggerOrActionToAdd.weekDays = $event))
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ]))
}